import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddBlogCategory({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          {/* MODAL TITLE */}
          <div className="modal_title">
            <h2>Add Blog Category</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="gap_p">
              {/* CATEGORY NAME */}
              <div className="control_group">
                <label>Blog Category Name</label>
                <TextField
                  placeholder="Enter Name"
                  fullWidth
                  hiddenLabel
                />
              </div>
            </div>

            {/* FOOTER BUTTON */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}